import { Box, Color } from '@gousto-internal/citrus-react'
import React, { RefObject } from 'react'
import { Hero, ThreeStepHero, LovedBy, PeekInTheBox } from '../components'
import { ValueForMoney } from '../components/ValueForMoney/ValueForMoney'
import { useFetchRafCampaignDetails } from '../hooks/useFetchRafCampaignDetails'
import { LandingPageContent } from '../../../landing-page-content/src/LandingPageContent'
import { Recipe } from '@library/menu-service'
// import { PromoBanner, PromoBannerText } from '../components/PromoBanner'

export type RafLandingPageType = {
  useIsRafLandingPageExperimentEnabled: () => boolean
  onScrollHandler: ({
    heroRef,
    stickyCTARef,
    setIsSticky,
    setMaxHeight,
  }: {
    heroRef: RefObject<HTMLDivElement>
    stickyCTARef: RefObject<HTMLDivElement>
    setIsSticky: (isSticky: boolean) => void
    setMaxHeight: (isSticky: number) => void
  }) => void
  onSignupCTAClick: () => void
  recipes: Recipe[]
  signupCTA: string
  applyDiscount: () => void
  isPromoBannerVisible: boolean
  promoBannerText: string
}

export const RafLandingPage = ({
  onScrollHandler,
  useIsRafLandingPageExperimentEnabled,
  onSignupCTAClick,
  recipes,
  signupCTA,
}: // applyDiscount,
// isPromoBannerVisible,
// promoBannerText,
RafLandingPageType) => {
  const { firstBoxDiscount, firstMonthDiscount, secondBoxDiscount, giftYourFriendCredit } =
    useFetchRafCampaignDetails()

  const isThreeStepHeroEnabled = !!secondBoxDiscount

  const isRafLandingPageExperimentEnabled = useIsRafLandingPageExperimentEnabled()

  return (
    // The PromoBanner below has been commented out temporarily
    // until the marketing experiment has concluded - https://gousto.atlassian.net/browse/BEET-414
    <Box paddingBottom={[10, 6]} bg={Color.White}>
      {/* {isRafLandingPageExperimentEnabled && isPromoBannerVisible && (
        <PromoBanner applyDiscount={applyDiscount}>
          <PromoBannerText>{promoBannerText}</PromoBannerText>
        </PromoBanner>
      )} */}
      {isThreeStepHeroEnabled && (
        <ThreeStepHero
          firstBoxDiscount={firstBoxDiscount}
          firstMonthDiscount={firstMonthDiscount}
          secondBoxDiscount={secondBoxDiscount}
          giftYourFriendCredit={giftYourFriendCredit}
          onScrollHandler={onScrollHandler}
          onCTAClick={onSignupCTAClick}
          signupCTA={signupCTA}
          isRafLandingPageExperimentEnabled={isRafLandingPageExperimentEnabled}
        />
      )}
      {!isThreeStepHeroEnabled && (
        <Hero
          firstBoxDiscount={firstBoxDiscount}
          firstMonthDiscount={firstMonthDiscount}
          giftYourFriendCredit={giftYourFriendCredit}
          onScrollHandler={onScrollHandler}
          onCTAClick={onSignupCTAClick}
          signupCTA={signupCTA}
          isRafLandingPageExperimentEnabled={isRafLandingPageExperimentEnabled}
        />
      )}
      {isRafLandingPageExperimentEnabled ? (
        <LandingPageContent
          onSignupCTAClick={onSignupCTAClick}
          signupCTA={signupCTA}
          recipes={recipes}
        />
      ) : (
        <>
          <LovedBy />
          <ValueForMoney />
          <PeekInTheBox />
        </>
      )}
    </Box>
  )
}
